import containerFuild from '../html-snippets/container-fuild';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-card-grid-item-rivoneed';
const buttonRivoneedHtml = buttonPrimaryHtml({
  text: 'Get Started',
  backgroundColor: '#ff0000',
  color: '#ffffff',
  radius: 8,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
});
const html = `
<div class="container">
  <div class="wrap-card">
    <div data-attribute="card-title" data-show="true" class="card-title">
      <h2 style="text-align: center">Any Surface. Any Angle. Light Your Way.</h2>
      <p style="text-align: center">Keep both hands on the task while the light stays in place.</p>
    </div>
    <div
      data-padding-item="false"
      data-border-radius-item="20"
      data-background-color-item="#ffffff"
      data-attribute="list-item"
      class="list-item"
      style="--border-radius-item: 20px; --background-color-item: #ffffff"
    >
      <div data-attribute="item-grid" class="item-grid">
        <div class="wrap-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cd5bdb21f49d9979df320.webp?w=50&amp;h=50&amp;q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="content">
          <h3>Magnetic Mount</h3>
          <p>Grips any metal. No holding. No slipping.</p>
        </div>
      </div>

      <div data-attribute="item-grid" class="item-grid">
        <div class="wrap-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cd5c3d92c0e4524f4d793.webp?w=50&amp;h=50&amp;q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="content">
          <h3>Swivel Hooks</h3>
          <p>Hang on doors, toolbox edges, anywhere.</p>
        </div>
      </div>

      <div data-attribute="item-grid" class="item-grid">
        <div class="wrap-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cd5c74dbe57df541549cd.webp?w=50&amp;h=50&amp;q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="content">
          <h3>Clamp Design</h3>
          <p>Clamps to workbenches, arms, any edge.</p>
        </div>
      </div>

      <div data-attribute="item-grid" class="item-grid">
        <div class="wrap-image">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/06/13/image-6a2cd5ccb6ac2d55d4c49d71.webp?w=50&amp;h=50&amp;q=80"
            alt=""
          />
        </div>
        <div data-attribute="text-item" class="content">
          <h3>Folding Joint</h3>
          <p>Flexible positioning for any angle.</p>
        </div>
      </div>
    </div>
    <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
  </div>
</div>

`;
export default containerFuild(html, css, {
  backgroundColor: '#1a1a1a',
  textColor: '#ffffff',
});
